import Vue from 'vue'
import Vuex from 'vuex'
import session from './modules/session.module'
import commonConfig from './modules/commonConfig.module'
import snackbarAlert from './modules/snackbarAlert.module'
import company from './modules/company.module'
import mainMenu from './modules/mainMenu.module'
import userClaims from './modules/userClaims.module'
import costCenter from './modules/costCenter.module'
import snackbar from './modules/snackbar.module'
import globalDrawer from './modules/globalDrawer.module'
import sessionExpiresTime from './modules/sessionExpiresTime.module'
import webcallMoveMarkers from './modules/webcallMoveMarkers.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    session,
    snackbarAlert,
    company,
    mainMenu,
    userClaims,
    costCenter,
    snackbar,
    globalDrawer,
    sessionExpiresTime,
    webcallMoveMarkers,
    commonConfig
  }
})
